import { notifyHandledException } from '../utils/errorLogger';

interface DetectedValues {
  country: {
    handle: string;
  };
}

export async function getBrowsingContext(): Promise<DetectedValues> {
  const cachedContext =
    window.sessionStorage.getItem('browsing_context') || '{}';

  if (cachedContext === '{}') {
    const response = await fetch('/browsing_context_suggestions.json');
    const { detected_values } = await response.json();

    window.sessionStorage.setItem(
      'browsing_context',
      JSON.stringify(detected_values)
    );

    return detected_values;
  }

  return JSON.parse(cachedContext);
}

export async function handleCountryConditionalElements(): Promise<void> {
  try {
    const detected_values = await getBrowsingContext();
    const conditionalElements = document.querySelectorAll<HTMLElement>(
      '[data-show-for-countries]'
    );

    conditionalElements.forEach((element) => {
      const dataset = element.dataset.showForCountries;
      if (!dataset) {
        return;
      }

      const countryCodes = dataset.split(',').map((code) => code.trim());
      const showElement = countryCodes.includes(detected_values.country.handle);

      if (showElement) {
        return;
      }

      element.remove();
    });
  } catch (error) {
    notifyHandledException(error as Error);
  }
}

export function initConditionalElements(): void {
  handleCountryConditionalElements().catch(notifyHandledException);
}
